export default "__VITE_ASSET__BQyvg9$9__"